import { useCompanyActivity, useCompanyNotes, useCreateCompanyNoteMutation, useCompanyTasks, useCompanyOverdueTasks, useCreateCompanyTaskMutation, useUpdateCompanyTaskMutation, useDeleteCompanyTaskMutation, useUpdateCompanyNoteMutation, useDeleteCompanyNoteMutation } from "service/crm";
import Activity from "../Activity/Activity";
import { useCompanyNoteComments, useCompanyTaskComments } from "service/crm/hooks/comments/comment";

const CompanyActivity = ({ companyUuid }: { companyUuid: string }) => (
  <Activity
    entityUuid={companyUuid}
    useActivityQuery={useCompanyActivity}
    useNotesQuery={useCompanyNotes}
    useCreateNote={useCreateCompanyNoteMutation}
    buildNotePayload={(companyUuid, values) => ({
      companyUuid,
      note: values.note!.trim(),
      associatedPersonUuid: values.associatedPersonUuid,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    })}
    useUpdateNote={useUpdateCompanyNoteMutation}
    buildUpdateNotePayload={(companyUuid, noteUuid, values) => ({
      companyUuid,
      noteUuid,
      note: values.note!.trim(),
      associatedPersonUuid: values.associatedPersonUuid,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    })}
    useDeleteNote={useDeleteCompanyNoteMutation}
      buildDeleteNotePayload={(companyUuid, noteUuid) => ({
      companyUuid,
      noteUuid,
    })}
    noteCommentHooks={useCompanyNoteComments}
    useTasksQuery={useCompanyTasks}
    useOverdueTasksQuery={useCompanyOverdueTasks}
    useCreateTask={useCreateCompanyTaskMutation}
    buildTaskPayload={(companyUuid, values) => ({
      companyUuid,
      title: values.title!.trim(),
      description: values.description?.trim() || undefined,
      dueAt: values.dueAt,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      taskOwnerUuid: values.taskOwnerUuid,
      priority: values.priority,
      taskType: values.taskType,
      taskStatus:values.taskStatus
    })}
    useUpdateTask={useUpdateCompanyTaskMutation}
    buildUpdateTaskPayload={(companyUuid, taskUuid, values) => ({
      companyUuid,
      taskUuid,
      title: values.title!.trim(),
      description: values.description?.trim() || undefined,
      dueAt: values.dueAt,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      taskOwnerUuid: values.taskOwnerUuid,
      priority: values.priority,
      taskType: values.taskType,
      taskStatus:values.taskStatus
    })}
    useDeleteTask={useDeleteCompanyTaskMutation}
    buildDeleteTaskPayload={(companyUuid, taskUuid) => ({
      companyUuid,
      taskUuid,
    })}
    taskCommentHooks={useCompanyTaskComments}
  />
);

export default CompanyActivity